import React, { FC } from 'react'
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { OpenNewFieldIcon } from '@sales-center/components'
import AlertTitle from '@mui/material/AlertTitle'
import { ENTITY_TYPES } from '@sales-center/common'
import LinearProgress from '@mui/material/LinearProgress'
import {
  MatchCreateLocationDialogs,
  useMatchCreateLocationFlow,
} from '@user/components/Location/MatchCreateLocation'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle/store'
import {
  createLocationPermission,
  LocationCreatePermOps,
  useCheckPermissions,
} from '@user/store/authorization/permissions'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  showPestPacLocationError?: boolean | null
}

export const CreateLocationFormPacketError: FC<Props> = (props) => {
  const { entityType, entityId, showPestPacLocationError } = props

  const tidalThemeActive = useTidalThemeActive()
  const flow = useMatchCreateLocationFlow({ entityId, entityType })
  const { saving, handleCreateNewLocation, handleMatchLocation } = flow
  const title = 'Create Location'

  const [canCreateLocations] = useCheckPermissions(
    createLocationPermission as LocationCreatePermOps,
  )

  if (showPestPacLocationError) {
    return (
      <>
        <Box>
          <Alert
            sx={{
              display: 'flex',
              alignItems: 'start',
            }}
            severity="error"
          >
            <AlertTitle>
              <Typography
                variant="subtitle1"
                sx={{
                  lineHeight: '24px',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
                color="#541313"
              >
                Template Requires a PestPac Account
              </Typography>
            </AlertTitle>

            <Typography variant="body2">
              You must associate this record with a location before sending this
              agreement.
            </Typography>
            {canCreateLocations && (
              <Box
                display={'flex'}
                flexDirection={'row'}
                gap={1.9}
                alignItems={'center'}
                mt="12px"
              >
                <Button
                  sx={{ color: '#1565C0', fontWeight: 500 }}
                  variant="text"
                  onClick={handleCreateNewLocation}
                  disabled={saving}
                >
                  {title}
                </Button>
                <Button
                  sx={{
                    color: '#1565C0',
                    fontWeight: 500,
                    alignItems: 'center',
                  }}
                  variant="text"
                  onClick={handleMatchLocation}
                  disabled={saving}
                  endIcon={
                    <Box sx={{ mt: tidalThemeActive ? '-4px' : '-6px' }}>
                      <OpenNewFieldIcon />
                    </Box>
                  }
                >
                  {flow.matchLocationTitle}
                </Button>
              </Box>
            )}
          </Alert>

          {saving && <LinearProgress color="primary" sx={{ width: '100%' }} />}
        </Box>
        <MatchCreateLocationDialogs
          entityId={entityId}
          entityType={entityType}
          flow={flow}
          title={title}
          tidalThemeActive={tidalThemeActive}
          addToPestPac={!!showPestPacLocationError}
        />
      </>
    )
  }
  return null
}
